module.exports = __webpack_public_path__ + "img/tr.2d7dda14.png";